<template>
  <div class="Evaluation">
    <h3 class="heading-lined">
      {{ heading }}
    </h3>
    <span :class="['Evaluation__Value odometer', valuation ? '' : 'text-muted']">
      {{ formatMoney(valuation) }}
    </span>
    <span class="Evaluation__Value-BTC" v-if="isBtc === false">
      ({{ $t("content.valuation.approx") }} {{ valuationInBtc }} BTC)
    </span>
    <div
      v-if="profitlossMode && !profitlossShowHistory"
      class="mt-4"
      style="margin-bottom: -1rem"
    >
      <h4 class="heading-lined">
        {{ $t("content.valuation.current_valuation") }}
      </h4>
      <span>
        {{ formatMoney(profitlossEvaluation) }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NumbersMixin from "./../mixins/numbers";

export default {
  name: "Evaluation",
  mixins: [NumbersMixin],
  computed: {
    valuation() {
      if (this.profitlossMode) {
        return this.profitlossTotalPL;
      }
      return this.currentEvaluation;
    },
    valuationInBtc() {
      let temp = this.currentEvaluationInBTC;
      if (this.profitlossMode) {
        temp = this.profitlossTotalPLInBTC;
      }
      return (temp || 0).toPrecision(4);
    },
    isBtc() {
      return this.currency === "BTC";
    },
    heading() {
      if (this.profitlossMode) {
        return this.profitlossShowHistory
          ? this.$t("profitloss.realized_profitloss")
          : this.$t("profitloss.total_balance");
      }
      return this.$t("content.valuation.current_valuation");
    },
    ...mapGetters({
      currency: "settings/currency",
      profitlossMode: "settings/profitlossMode",
      currentEvaluation: "portfolio/currentEvaluation",
      currentEvaluationInBTC: "portfolio/currentEvaluationInBTC",
      profitlossTotalPL: "profitloss/profitlossTotalPL",
      profitlossTotalPLInBTC: "profitloss/profitlossTotalPLInBTC",
      profitlossEvaluation: "profitloss/profitlossEvaluation",
      profitlossEvaluationInBTC: "profitloss/profitlossEvaluationInBTC",
      profitlossShowHistory: "profitloss/showHistory",
    }),
  },
};
</script>

<style lang="scss">
@import "~@/scss/variables";
@import "~@/scss/mixins";

.Evaluation {
  margin-bottom: 50px;
}

.Evaluation__Value {
  display: block;
  font-size: 65px;
  color: $color-secondary;
  //text-shadow: 3px 3px 0 rgba(34,42,84,0.13); //  bye-bye, old friend
  font-weight: 700;
  line-height: 1;

  @include breakpoint-manual(max-width, $break-small) {
    font-size: 40px;
  }
}

.Evaluation__Value-BTC {
  display: block;
  margin-top: 5px;
  font-size: 15px;
  color: #8da3ad;
}
</style>
